import { messageFromError, type ReportTimeInput, type ReportTimeSuccess } from '@terros/common'
import { useQueries } from '@tanstack/react-query'
import { reportTimeKey } from '../keys'
import { useServerRequest } from '../api'

export type ReportTimesResult = {
  results: (ReportTimeSuccess | undefined)[]
  pending: boolean[]
  isLoading: boolean
  isFetching: boolean
  error: string | undefined
  refetch: VoidFunction
}

export function useReportTimes(inputs: ReportTimeInput[], enabled = true): ReportTimesResult {
  const serverRequest = useServerRequest<ReportTimeInput, ReportTimeSuccess>('/report/time')

  return useQueries({
    queries: inputs.map((input) => ({
      queryKey: reportTimeKey(input),
      queryFn: () => serverRequest(input),
      retry: false,
      enabled,
    })),
    combine: (results): ReportTimesResult => ({
      results: results.map((result) => result.data),
      pending: results.map((result) => result.isPending),
      isLoading: results.some((result) => result.isLoading),
      isFetching: results.some((result) => result.isFetching),
      error: messageFromError(results.find((result) => result.error)?.error),
      refetch: () => results.forEach((result) => result.refetch()),
    }),
  })
}
